<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import fieldVisibilityMixin from '../../../mixins/fieldVisibility';

export default {
  name: 'AvContractTransferOfficerForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
  },
  mixins: [fieldVisibilityMixin],
  props: {
    avContract: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hiddenFieldsDomain: 'avContract',
    };
  },
};
</script>

<template>
  <div class="avContract-detail-tab main-tab">
    <v-layout row wrap>
      <!-- Basic information left column -->
      <v-flex md8 xs12>
        <h4 class="avContract-detail-tab-title">Weisungsbefugte</h4>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.transferOfficers')" md4 py-0>
            <v-textarea
              v-model="avContract.transferOfficers"
              label="Weisungsbefugte"
              class="caption"
            />
          </v-flex>

        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
